var map = {
	"./music-instructions.json": 4475,
	"./music-library-intro2024.json": 4476,
	"./music-library-launch2024.json": 4477,
	"./music-progression.json": 4478,
	"./startSourcesAdvanced.json": 4479,
	"./startSourcesSimple.json": 4480,
	"./startSourcesSimple2.json": 4481,
	"./startSourcesTracks.json": 4482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4254;